

export default {
  locale: 'fr',
  Pagination: {
    items_per_page: '/ page',
    jump_to: 'Aller à',
    jump_to_confirm: 'confirmer',
    page: '',
    prev_page: 'Page précédente',
    next_page: 'Page suivante',
    prev_5: '5 Pages précédentes',
    next_5: '5 Pages suivantes',
    prev_3: '3 Pages précédentes',
    next_3: '3 Pages suivantes',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Sélectionner une date',
      rangePlaceholder: ['Date de début', 'Date de fin'],
      locale: 'fr_BE',
      today: "Aujourd'hui",
      now: 'Maintenant',
      backToToday: "Aujourd'hui",
      ok: 'Ok',
      clear: 'Rétablir',
      month: 'Mois',
      year: 'Année',
      timeSelect: "Sélectionner l'heure",
      dateSelect: "Sélectionner l'heure",
      monthSelect: 'Choisissez un mois',
      yearSelect: 'Choisissez une année',
      decadeSelect: 'Choisissez une décennie',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mois précédent (PageUp)',
      nextMonth: 'Mois suivant (PageDown)',
      previousYear: 'Année précédente (Ctrl + gauche)',
      nextYear: 'Année prochaine (Ctrl + droite)',
      previousDecade: 'Décennie précédente',
      nextDecade: 'Décennie suivante',
      previousCentury: 'Siècle précédent',
      nextCentury: 'Siècle suivant'
    },
    timePickerLocale: {
      placeholder: "Sélectionner l'heure"
    }
  },
  TimePicker: {
    placeholder: "Sélectionner l'heure"
  },
  Calendar: {
    lang: {
      placeholder: 'Sélectionner une date',
      rangePlaceholder: ['Date de début', 'Date de fin'],
      locale: 'fr_BE',
      today: "Aujourd'hui",
      now: 'Maintenant',
      backToToday: "Aujourd'hui",
      ok: 'Ok',
      clear: 'Rétablir',
      month: 'Mois',
      year: 'Année',
      timeSelect: "Sélectionner l'heure",
      dateSelect: "Sélectionner l'heure",
      monthSelect: 'Choisissez un mois',
      yearSelect: 'Choisissez une année',
      decadeSelect: 'Choisissez une décennie',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mois précédent (PageUp)',
      nextMonth: 'Mois suivant (PageDown)',
      previousYear: 'Année précédente (Ctrl + gauche)',
      nextYear: 'Année prochaine (Ctrl + droite)',
      previousDecade: 'Décennie précédente',
      nextDecade: 'Décennie suivante',
      previousCentury: 'Siècle précédent',
      nextCentury: 'Siècle suivant'
    },
    timePickerLocale: {
      placeholder: "Sélectionner l'heure"
    }
  },
  global: {
    placeholder: 'Sélectionner'
  },
  Table: {
    filterTitle: 'Filtrer',
    filterConfirm: 'OK',
    filterReset: 'Réinitialiser'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuler',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuler'
  },
  Transfer: {
    searchPlaceholder: 'Recherche',
    itemUnit: 'élément',
    itemsUnit: 'éléments'
  },
  Upload: {
    uploading: 'Téléchargement...',
    removeFile: 'Effacer le fichier',
    uploadError: 'Erreur de téléchargement',
    previewFile: 'Fichier de prévisualisation',
    downloadFile: 'Télécharger un fichier'
  },
  Empty: {
    description: 'Aucune donnée'
  },
  Text: {
    edit: 'éditer',
    copy: 'copier',
    copied: 'copie effectuée',
    expand: 'développer'
  }
};
